// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1krbJ","rootMobile":"styles_rootMobile__1_9ai"};